import type { Surface } from "../config/types";

export interface SurfaceRegion {
    left: number;
    top: number;
    right: number;
    bottom: number;
    surface: Surface;
    gripBonus?: number;
}

export interface TrailSlice {
    x: number;
    halfWidth: number;
    surface: Surface;
}

function regionUnder(xM: number, yM: number, regions: SurfaceRegion[]): SurfaceRegion | null {
    for (let i = regions.length - 1; i >= 0; i--) {
        const r = regions[i];
        if (xM >= r.left && xM <= r.right && yM >= r.top && yM <= r.bottom) return r;
    }
    return null;
}

export function gripBonusAt(xM: number, yM: number, regions: SurfaceRegion[]): number {
    return regionUnder(xM, yM, regions)?.gripBonus ?? 1;
}

export function surfaceAt(
    xM: number,
    yM: number,
    regions: SurfaceRegion[],
    trail: TrailSlice | null,
    base: Surface,
): Surface {
    const region = regionUnder(xM, yM, regions);
    if (region) return region.surface;
    if (trail && Math.abs(xM - trail.x) <= trail.halfWidth) return trail.surface;
    return base;
}
